<template>
  <div class="wrapper wrapper_pc recruit">
    <h2>人才招募</h2>
    <div class="con">
      <ul class="flexCenter">
        <li class="animate__animated animate__fadeInLeft">
          <img src="../../assets/imgs/barrageGame/recruit_l.png" alt="">
          <a href="https://www.tiktok.com/@morefun61?_t=8s62hYGHftP&_r=1" target="_blank"></a>
        </li>
        <li class="animate__animated animate__fadeInRight">
          <img src="../../assets/imgs/barrageGame/recruit_r.png" alt="">
          <a href="https://line.me/ti/p/3d8rlmukYl" target="_blank"></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: "Recruit",
  data: function () {
    return {};
  }
};
</script>

<style lang="stylus" scoped>

@keyframes btnLightsAni{
  0%{
    left:-50%;
    top:0;
  }
  100%{
    left:100%;
    top:100%;
  }
}

.flexCenter{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.recruit{
  margin-bottom: 90px;
}
.wrapper {
  width: 100%;
  background: #fff;

  h2 {
    color: #4b4a47;
    font-size: 47px;
    text-align: center;
    margin:106px 0 29px;
  }

  .con {
    width: 890px;
    margin: 0 auto;
    text-align: center;
    ul{
      li{
        position: relative;
        list-style-type: none;
        margin-bottom: 23px;
        a{
          display: block;
          width: 115px;
          height: 31px;
          background: url(../../assets/imgs/barrageGame/contact.png) no-repeat;
          background-size: 100% 100%;
          position: absolute;
          overflow: hidden;
          &::before{
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            background: linear-gradient(to bottom, transparent, rgba(255,255,255,.6), transparent);
            transform: rotate(-45deg);
            animation: btnLightsAni 1.8s ease-in 0s infinite;
          }
        }
        &:nth-child(1){
          a{
            left: 26px;
            top: 94px;
          }
        }
        &:nth-child(2){
          margin-left: 25px;
          a{
            left: 146px;
            top: 94px;
          }
        }
      }
    }
    p {
      color: #4b4a47;
      font-size: 20px;
      margin: 18px 0 175px;
    }
  }
}
</style>
